import type { RolePlayInterviewSectionSettings } from "@repo/app-types/entities/interviewSection/settings";
import type { FC } from "react";
import { BaseInterviewSectionDefinitionCard } from "../card.js";
import { RolePlayInterviewSectionDefinitionSettings } from "./settings.js";

export interface RolePlayInterviewSectionDefinitionCardProps {
  interviewSectionDefinitionId: string;
  settings: RolePlayInterviewSectionSettings;
  onChange: (
    interviewSectionDefinitionId: string,
    newSettings: RolePlayInterviewSectionSettings,
  ) => void;
  onDelete?: (interviewSectionDefinitionId: string) => void;
}

export const RolePlayInterviewSectionDefinitionCard: FC<
  RolePlayInterviewSectionDefinitionCardProps
> = (props) => {
  return (
    <BaseInterviewSectionDefinitionCard
      interviewSectionDefinitionId={props.interviewSectionDefinitionId}
      title={props.settings.title || "Role play interview"}
      subtitle="Simulates a conversation that candidates will need to do on the job."
      onDelete={props.onDelete}
    >
      <RolePlayInterviewSectionDefinitionSettings
        interviewSectionDefinitionId={props.interviewSectionDefinitionId}
        settings={props.settings}
        onChange={props.onChange}
      />
    </BaseInterviewSectionDefinitionCard>
  );
};
